import store, { modulesName } from '@/store';
import studentService from '@/services/student';
import commentsStore from '@/views/comments/comments-store';

const MAINTENANCE_RELOAD_FLAG = 'maintenanceReloadTriggered';

const checkMaintenanceMode = async () => {
  try {
    // Check if the app is in maintenance mode by requesting the app_offline.htm file with HEAD method
    const response = await fetch('/app_offline.htm', {
      method: 'HEAD',
      cache: 'no-store',
    });

    // ASP.NET Core Module maintenance mode returns 503 for EVERY request while
    // app_offline.htm exists, including the request for that file itself.
    // A real "not in maintenance" state returns 404 for app_offline.htm.
    const isMaintenance = response.status !== 404;

    if (isMaintenance) {
      if (sessionStorage.getItem(MAINTENANCE_RELOAD_FLAG)) {
        return true;
      }

      sessionStorage.setItem(MAINTENANCE_RELOAD_FLAG, '1');
      window.location.reload();
      return true;
    }

    sessionStorage.removeItem(MAINTENANCE_RELOAD_FLAG);
  } catch {
    // Network error: assume the app is not in maintenance mode
    // and let normal navigation/error handling proceed.
  }

  return false;
};

export const applyEvents = (router) => {
  router.beforeEach(async (to, _, next) => {
    if (await checkMaintenanceMode()) {
      return;
    }

    //Always init User module to get User Information
    if (await store.getters[`${modulesName.userModuleName}/authenticated`]) {
      store.dispatch(`${modulesName.userModuleName}/init`);
    } else {
      await store.dispatch(`${modulesName.userModuleName}/init`);
    }
    const meta = to.matched
      .filter((x) => x.meta)
      .map((x) => x.meta)
      .reduce((x, y) => ({ ...x, ...y }), {});
    if (meta.authorization) {
      if (meta.authorization.authenticated === true) {
        if (!store.getters[`${modulesName.userModuleName}/authenticated`]) {
          await store.dispatch(`${modulesName.userModuleName}/login`);
        }
      }

      if (meta.authorization.authenticated === false) {
        if (store.getters[`${modulesName.userModuleName}/authenticated`]) {
          return next({ name: 'dashboard' });
        }
      }
    }
    // const canLeavePage = await store.dispatch('canLeavePage');
    // if (canLeavePage) {
    //   store.commit('setFormDirty', { value: false });
    //   next();
    // }
    const isWelcomePortal = to.matched.some(
      (item) => item.meta.isWelcomePortal
    );
    if (isWelcomePortal === true) {
      next();
    }

    if (!to.path.startsWith('/student/comments')) {
      commentsStore.commit('reset');
    }

    if (to.path.startsWith('/student/comments')) {
      const studentSieId = to.params.studentSieId?.trim();

      if (
        !!to.params.studentSieId &&
        studentSieId != store.getters.SelectedStudent?.studentId
      ) {
        const webServiceSearchOnly =
          store.getters.WebServiceStudentSearchEnabled;

        const { data: student } = await studentService.getBySie(
          to.params.studentSieId.toString().trim(),
          webServiceSearchOnly
        );

        store.state.bypassStudentChangeAlert = true;
        await store.dispatch('$_student/setStudentDetails', {
          studentId: student.studentId,
          autoCreateStudentData: webServiceSearchOnly,
          student,
          selectThisStudent: true,
        });

        store.commit('$_student/setSelectedStudent', student);
        store.commit('$_student/toggleSearchMenu', false);
        store.commit('$_student/showStudentBox', true);
      }
    }

    return next();
  });

  router.afterEach(async (to) => {
    if (to.matched.some((route) => route.meta.IsParent)) {
      store.dispatch('setParentRouter', to);
    }
  });
};

// router.beforeEach(async (to, from, next) => {
//   const logged = sessionStorage.getItem('user-token'); //Temp this is not real fix

//  {
//     let result = to.hash != '' ? to.hash.split('&') : [];
//     store.commit('SetAccountData', result);

//     if (store.state.userHasValidRole === null) {
//       //Validate rol here
//       const hasValidRole = await validateApplicationRole().then((resp) => {
//         return resp.data;
//       });

//       if (!hasValidRole) {
//         store.commit('logoff');
//         return;
//       }

//       store.commit('setUserHasValidRole', hasValidRole);
//     }

//   }
// });
